export default __webpack_public_path__ + "static/media/2b12f70b9b4c425585926f67bfce1454.svg";